// TODO CHANGE VALUES
export const environment = {
  production: false,
  apiUrl: 'api/ch',
  version: require('../../package.json').version,
  isSecure: true,
  shouldPrefillTestingData: false,
  issuer: 'Assekuranz AR PROD',
  cognitoConf: {
    region: 'eu-central-1',
    apiVersion: '2016-04-18',
    accessKeyId: 'AKIA33FGRLTR3MR4N5OS',
    secretAccessKey: '0kCW1TUufZnU/zCxkr/lbdXbSe2M3qNGtrmFOYwUGxG+d9ftfkc7u',
    clientSecret: 'ot6papr5l3atfu2qf4s6vm5lnhgnjqkjl7794nm5dvhp5cse9qv',
    clientId: '3o96huh9s01slek7oo2l3cjfil',
    userPoolId: 'eu-central-1_71esw9KSX',
  },
};
